const userActions = (state = {
    typing: {}
}, action) => {
    switch (action.type) {
        case 'TEAM_CHANGE':
            return {
                typing: {}
            };

        case 'USER_ACTION_TYPING_START':
            if (action.payload.discussionId in state.typing) {
                if (state.typing[action.payload.discussionId].includes(action.payload.userId)) {
                    return state;
                }

                state.typing[action.payload.discussionId] = [...state.typing[action.payload.discussionId], action.payload.userId];

                return Object.assign({}, state, {
                    typing: Object.assign({}, state.typing)
                });
            }

            state.typing[action.payload.discussionId] = [action.payload.userId];

            return Object.assign({}, state, {
                typing: Object.assign({}, state.typing)
            });

        case 'USER_ACTION_TYPING_END':
            if (!(action.payload.discussionId in state.typing)) {
                return state;
            }

            state.typing[action.payload.discussionId] = state.typing[action.payload.discussionId].filter(userId => userId !== action.payload.userId);

            return Object.assign({}, state, {
                typing: Object.assign({}, state.typing)
            });

        default:
            return state;
    }
}

export default userActions;
